interface HeaderClientProps {
    rightContent?: React.ReactNode;
    children?: React.ReactNode;
    mode: 'desktop' | 'mobile';
}

export function HeaderClient({ rightContent, children, mode }: HeaderClientProps) {
    if (mode === 'desktop') {
        return (
            <div className="hidden md:flex items-center gap-1 px-4">
                {rightContent}
                {children}
            </div>
        );
    }

    return (
        <div className="md:hidden w-full px-4 pb-3 -mt-2">
            <div className="flex justify-end gap-1">
                {rightContent}
                {children}
            </div>
        </div>
    );
}
